<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="md-12">
        <servicerequestdetails v-if="isfaq"></servicerequestdetails>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";
export default {
  name: "Setup",
  components: {
    servicerequestdetails,
  },
  data: () => {
    return {
      isfaq: true,
    };
  },
  mounted: async function () {
    this.provider = this.$store.getters["auth/getUserID"];
  },
  computed: {},
};
</script>

<style scoped>
.mymodalclass > div {
  margin-top: 45px !important;
}
.text-center {
  text-align: center !important;
}
[data-font="20"] {
  font-size: 20px;
}
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
<style>
table.table-bordered > tbody > tr {
  /* text-transform: capitalize; */
  text-align: center;
}
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
</style>
